import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: auto;

  @media(max-width: 800px) {
    width: 90vw;
    margin-bottom: 80px;
  }
`;

export const Title = styled.div`
  text-align: center;
  font-size: 28px;
  margin-top: 20px;
  font-weight: bold;
`;

export const ContainerRegister = styled.div`
  width: 600px;
  height: 400px;
  display: flex;
  justify-content: center;
  margin: auto;

  @media(max-width: 800px) {
    width: 100vw;
  }

  .label {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    font-weight: bold;

    @media(max-width: 800px) {
      width: 90vw;
    }
  }

  .input {
    width: 580px;
    height: 25px;
    color: #808080;
    padding: 0;
    border: none;
    border-bottom: 1px solid;
    border-radius: 0px;
    border-color: #3C3C3B;

    @media(max-width: 800px) {
      width: 90vw;
    }
  }

  .input:focus {
    border-right-width: 1px !important;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .container-submit {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    @media(max-width: 800px) {
      width: 90vw;
      flex-direction: column;
    }
  }

  span {
    font-size: 15px;
  }

  .btn-send {
    font-size: 2%;
    width: 145px;
    height: 43px;
    border: none;
    background-color: black;
    color: white;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 20px;
    letter-spacing: 1px;
      :hover{
        background-color: white;
        color: black;
        border: 1px solid black;
      }
      :disabled{
        background-color: #D6D6D6;
        color: black;
        cursor: not-allowed;
      }

      @media(max-width: 800px) {
        width: 90vw;
        margin: auto;
        height: 45px;
        margin-top: 30px;
      }
  }

  .btn-cancel {
    font-size: 2%;
    width: 145px;
    height: 43px;
    border-width: 3px solid;
    border-radius: 0px;
    border-color: #3C3C3B;
    background-color: white;
    color: black;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 20px;
    letter-spacing: 1px;
      :hover{
        box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 5px 0px;
      }

      @media(max-width: 800px) {
        width: 90vw;
        margin: auto;
        height: 45px;
        margin-top: 30px;
      }
  }

  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    content: none;
  }
`;